import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { useResponsive } from '~/client-flow/contexts';
import { useIoContext } from '~/contexts';
import { useStore } from '~/store/store-context';
import TryAnchorBanner from '../TryAnchorBanner/TryAnchorBanner';
import SignedAgreement from './SignedAgreement.json';
import styles from './SignedAgreementAnimationWrapper.module.scss';
const SignedAgreementAnimationWrapper = (param)=>{
    let { children, testId } = param;
    const [showBanner, setShowBanner] = useState(false);
    const [contentShift, setContentShift] = useState(false);
    const [shouldTransform, setShouldTransform] = useState(false);
    const { isDesktop } = useResponsive();
    const pageRef = useRef(null);
    const contentRef = useRef(null);
    const hasAVendorAccount = !!useStore((state)=>{
        var _state_userInfo;
        return (_state_userInfo = state.userInfo) === null || _state_userInfo === void 0 ? void 0 : _state_userInfo.hasAVendorAccount();
    });
    const { Lottie } = useIoContext();
    useEffect(()=>{
        const calculateTransform = ()=>{
            var _ref, _ref1;
            var _pageRef_current, _contentRef_current;
            const pageHeight = (_ref = (_pageRef_current = pageRef.current) === null || _pageRef_current === void 0 ? void 0 : _pageRef_current.getBoundingClientRect().height) !== null && _ref !== void 0 ? _ref : 0;
            const contentHeight = (_ref1 = (_contentRef_current = contentRef.current) === null || _contentRef_current === void 0 ? void 0 : _contentRef_current.getBoundingClientRect().height) !== null && _ref1 !== void 0 ? _ref1 : 0;
            const topMargin = (pageHeight - contentHeight) / 2;
            const marginFromTop = isDesktop ? 64 + 16 + 16 : 100;
            setShouldTransform(topMargin === 0 || topMargin - marginFromTop > 0);
        };
        calculateTransform();
        window.addEventListener('resize', calculateTransform);
        return ()=>window.removeEventListener('resize', calculateTransform);
    }, [
        isDesktop
    ]);
    const handleLottieComplete = ()=>{
        setContentShift(!hasAVendorAccount);
        setTimeout(()=>setShowBanner(true), 300);
    };
    const hasBanner = !hasAVendorAccount;
    return /*#__PURE__*/ _jsxs("div", {
        ref: pageRef,
        style: {
            minHeight: '100%',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: hasBanner ? 'flex-start' : shouldTransform ? 'center' : 'flex-start',
            alignItems: 'center'
        },
        "data-testid": testId,
        className: styles.animationWrapper,
        children: [
            /*#__PURE__*/ _jsx("div", {
                style: {
                    flex: hasBanner ? 1 : undefined,
                    display: 'flex',
                    justifyContent: shouldTransform ? 'center' : 'flex-start',
                    alignItems: 'center',
                    width: '100%'
                },
                children: /*#__PURE__*/ _jsx(motion.div, {
                    animate: contentShift && shouldTransform ? {
                        y: -32
                    } : {
                        y: 0
                    },
                    transition: {
                        duration: 0.3,
                        ease: 'easeInOut'
                    },
                    children: /*#__PURE__*/ _jsxs("div", {
                        ref: contentRef,
                        style: {
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center'
                        },
                        children: [
                            /*#__PURE__*/ _jsx(Lottie, {
                                animationData: SignedAgreement,
                                className: styles.signedAgreement,
                                loop: false,
                                onComplete: handleLottieComplete
                            }),
                            children
                        ]
                    })
                })
            }),
            hasBanner && /*#__PURE__*/ _jsx(TryAnchorBanner, {
                showBanner: showBanner,
                isFixed: shouldTransform,
                contentShift: contentShift
            })
        ]
    });
};
export default SignedAgreementAnimationWrapper;
